import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
//
// 割引率を小数点表示から%表示になおして返す
const convertDiscountRate = (discountRate) => {
    return discountRate.replace('%', '');
};
const SaleItemDiscountRate = ({ discountRate, cssSubClass, isPSPlus, isOnSale }) => {
    const [className, setClassName] = useState();
    const [labelName, setLabelName] = useState();
    useEffect(() => {
        if (isOnSale === undefined) {
            return;
        }
        // セール中
        if (isOnSale) {
            setLabelName(convertDiscountRate(discountRate));
            // psplusセールの場合はcssクラス名を追加
            if (isPSPlus) {
                setClassName(classNames('sale-item-discount-rate', cssSubClass, 'psplus'));
            }
            else {
                setClassName(classNames('sale-item-discount-rate', cssSubClass));
            }
        }
        else {
            setLabelName('終了しました');
            setClassName(classNames('sale-item-discount-rate', cssSubClass, 'disabled'));
        }
    }, [
        isOnSale
    ]);
    return (React.createElement("div", { className: className },
        labelName,
        React.createElement("span", null, "%OFF")));
};
SaleItemDiscountRate.defaultProps = {
    isPSPlus: false
};
export default SaleItemDiscountRate;
